const updateUrlParameter = (url, paramName, paramValue) => {
  // 创建一个URL对象
  let newUrl = new URL(url);

  // 使用URLSearchParams来处理查询字符串
  let params = new URLSearchParams(newUrl.search);

  // 设置新的参数值
  params.set(paramName, paramValue);

  // 更新URL对象的查询字符串
  newUrl.search = params.toString();

  // 返回新的URL字符串
  return newUrl.toString();
};

/**
 * 从URL中移除指定的参数
 * @param url 原始URL
 * @param paramName 要移除的参数名
 * @returns 移除参数后的URL
 */
const removeUrlParameter = (url, paramName) => {
  // 创建一个URL对象
  let newUrl = new URL(url);

  // 使用URLSearchParams来处理查询字符串
  let params = new URLSearchParams(newUrl.search);

  // 删除指定的参数
  params.delete(paramName);

  // 更新URL对象的查询字符串
  newUrl.search = params.toString();

  // 返回新的URL字符串
  return newUrl.toString();
};

export const PDUtils = {
  updateUrlParameter,
  removeUrlParameter,
};
